import type { StoreProductReapproParam } from '@gozoki/api-types'
import { gozokiApiWithAuth } from '../gozokiApi'

export const fetchStoreProductReapproParams = async (
  storeId: number,
  reapproCategoryId: number,
) => {
  const response = await gozokiApiWithAuth.get<StoreProductReapproParam[]>(
    '/store-product-reappro-params',
    { params: { storeId, reapproCategoryId } },
  )
  return response.data
}
